import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DocumentPreviewPaneComponent } from '../../../components/document-preview-pane/document-preview-pane.component';

@Component({
    selector: 'app-document-preview-modal',
    templateUrl: './document-preview-modal.component.html',
    styleUrls: ['./document-preview-modal.component.css']
})
export class DocumentPreviewModalComponent {
    @ViewChild(DocumentPreviewPaneComponent) previewPane?: DocumentPreviewPaneComponent;

    @Input() fileName = '';
    fileLoader: (() => Observable<Blob>) | null = null;

    constructor(public activeModal: NgbActiveModal) {
    }

    @Input()
    set loadFile(loader: () => Observable<Blob>) {
        this.fileLoader = loader;
    }

    download(): void {
        this.previewPane?.download();
    }
}

export function openDocumentPreview(modalService: NgbModal,
                                    fileName: string,
                                    loadFile: () => Observable<Blob>): void {
    const modalRef = modalService.open(DocumentPreviewModalComponent, {
        size: 'xl',
        scrollable: true
    });
    const preview = modalRef.componentInstance as DocumentPreviewModalComponent;
    preview.fileName = fileName;
    preview.loadFile = loadFile;
}
